import React, { useEffect, useState } from 'react';
import setUiMessage from '../../../Utilities/Tostify';
import { post } from '../../Auths/AuthToken';
import { useSelector } from 'react-redux';
import useFormValidation from '../../../hooks/zodFormValidation';
import appSchema from '../../../schema/appSchema';
import { getMaskPhone, getMaskZip } from '../../../Utilities/Utilities';
import Button from '../../Button';

function AddEditReferralInsurancePopup({ onClose, onReload, editPopup }) {
  const { user } = useSelector((store) => store.auth);

  const [data, setData] = useState('');
  const [formData, setFormData] = useState({
    id: '',
    insPayerName: '',
    insuranceTypeId: '',
    insuranceAddress: '',
    insuranceCity: '',
    insuranceState: '',
    insuranceZip: '',
    insuranceEmail: '',
    insuranceDeskPhone: '',
    insuranceCell: '',
    insuranceFax: '',
  });
  const [isSubmit, setSubmit] = useState(false);

  const { errors, validateForm } = useFormValidation({
    schema: appSchema.referralInsuranceSchema(),
    formData: formData,
    isSubmit,
  });

  useEffect(() => {
    (async () => {
      try {
        const response = await post('api/commonTask/openAddEditMasterPopup', {
          userId: user?.id,
          insuranceId: editPopup?.referringMasterId,
          popUpType: 'insurance',
        });
        if (response.status === 200) {
          setData(response.data);
          const master = response.data.insuranceMaster[0];
          setFormData({
            id: master?.id || '',
            insPayerName: master?.insurance_company_name || '',
            insuranceTypeId: master?.insurance_master_id || '',
            insuranceAddress: master?.address_1 || '',
            insuranceCity: master?.city || '',
            insuranceState: master?.state || '',
            insuranceZip: getMaskZip(master?.zip || ''),
            insuranceEmail: master?.email || '',
            insuranceDeskPhone: getMaskPhone(master?.phone_l || ''),
            insuranceCell: getMaskPhone(master?.phone_m || ''),
            insuranceFax: getMaskPhone(master?.fax || ''),
          });
        }
      } catch (error) {
        setUiMessage('err', error.message);
      }
    })();
  }, [editPopup, user?.id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (
      name === 'insuranceDeskPhone' ||
      name === 'insuranceCell' ||
      name === 'insuranceFax'
    ) {
      setFormData({ ...formData, [name]: getMaskPhone(value) });
    } else if (name === 'insuranceZip') {
      setFormData({ ...formData, [name]: getMaskZip(value) });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const onSaveUpdate = async () => {
    setSubmit(true);
    const validationError = validateForm();
    if (validationError) return;

    try {
      const response = await post('api/commonTask/saveUpdateInsuranceMaster', {
        userId: user?.id,
        insuranceId: editPopup?.referringMasterId || '',
        ...formData,
      });
      if (response.status === 200) {
        setUiMessage('suc', 'Insurance added successfully.');
        onReload();
        onClose();
      }
    } catch (error) {
      setUiMessage('err', error.message);
    }
  };

  return (
    <div className="modalBackground">
      <div className="openReferringProviderPopup">
        {/* HEADER */}
        <div className="addressBookHeader flex justify-between items-center">
          <span className="addressTitle">
            <h2>Add New Insurance</h2>
          </span>
          <Button className="addressClose" variant="circle" onClick={onClose}>
            X
          </Button>
        </div>

        {/* BODY */}
        <div className="addressBody">
          {/* PAYER NAME & TYPE */}
          <div className="addressBodyRow">
            <div style={{ float: 'left', width: '49%' }}>
              <div className="addressBodyRow">Payer Name *</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh h-8"
                  type="text"
                  name="insPayerName"
                  value={formData.insPayerName}
                  onChange={handleChange}
                  placeholder="Payer Name"
                />
                <p className="error-msg">
                  {errors?.insPayerName && errors?.insPayerName?.message}
                </p>
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            <div style={{ float: 'left', width: '49%' }}>
              <div className="addressBodyRow">Type *</div>
              <div className="addressBodyRow">
                <select
                  name="insuranceTypeId"
                  id="insurance_type_id"
                  className="chzn-select addressBookSearh h-8"
                  value={formData.insuranceTypeId}
                  onChange={handleChange}
                >
                  <option value=""></option>
                  {data?.insuranceType?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.title}
                    </option>
                  ))}
                </select>
                <p className="error-msg">
                  {errors?.insuranceTypeId && errors?.insuranceTypeId?.message}
                </p>
              </div>
            </div>
          </div>

          {/* STREET ADDRESS */}
          <div className="addressBodyRow">Street Address</div>
          <div className="addressBodyRow">
            <input
              className="addressBookSearh h-8"
              type="text"
              name="insuranceAddress"
              value={formData.insuranceAddress}
              onChange={handleChange}
              placeholder="Street Address"
            />
            <p className="error-msg">
              {errors?.insuranceAddress && errors?.insuranceAddress?.message}
            </p>
          </div>

          {/* CITY / STATE / ZIP */}
          <div className="addressBodyRow">
            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">City</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh h-8"
                  type="text"
                  name="insuranceCity"
                  value={formData.insuranceCity}
                  onChange={handleChange}
                  placeholder="City"
                />
                <p className="error-msg">
                  {errors?.insuranceCity && errors?.insuranceCity?.message}
                </p>
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">State</div>
              <div className="addressBodyRow">
                <select
                  name="insuranceState"
                  id="insuranceState"
                  className="chzn-select addressBookSearh h-8"
                  value={formData.insuranceState}
                  onChange={handleChange}
                >
                  <option value=""></option>
                  {data?.stateMaster?.map((state) => (
                    <option key={state.id} value={state.id}>
                      {state.stateName}
                    </option>
                  ))}
                </select>
                <p className="error-msg">
                  {errors?.insuranceState && errors?.insuranceState?.message}
                </p>
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">Zip *</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh h-8"
                  type="text"
                  name="insuranceZip"
                  value={formData.insuranceZip}
                  onChange={handleChange}
                  maxLength="10"
                  placeholder="Zip"
                />
                <p className="error-msg">
                  {errors?.insuranceZip && errors?.insuranceZip?.message}
                </p>
              </div>
            </div>
          </div>

          {/* EMAIL */}
          <div className="addressBodyRow">Email</div>
          <div className="addressBodyRow">
            <input
              className="addressBookSearh h-8"
              type="text"
              name="insuranceEmail"
              value={formData.insuranceEmail}
              onChange={handleChange}
              placeholder="Email address"
            />
            <p className="error-msg">
              {errors?.insuranceEmail && errors?.insuranceEmail?.message}
            </p>
          </div>

          {/* PHONES */}
          <div className="addressBodyRow">
            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">Desk Phone</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh h-8"
                  type="text"
                  name="insuranceDeskPhone"
                  value={formData.insuranceDeskPhone}
                  onChange={handleChange}
                  maxLength="15"
                  placeholder="(000) 000-0000"
                />
                <p className="error-msg">
                  {errors?.insuranceDeskPhone &&
                    errors?.insuranceDeskPhone?.message}
                </p>
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">Cell Phone</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh h-8"
                  type="text"
                  name="insuranceCell"
                  value={formData.insuranceCell}
                  onChange={handleChange}
                  maxLength="15"
                  placeholder="(000) 000-0000"
                />
                <p className="error-msg">
                  {errors?.insuranceCell && errors?.insuranceCell?.message}
                </p>
              </div>
            </div>

            <div style={{ float: 'left', width: '2%' }}>&nbsp;</div>

            <div style={{ float: 'left', width: '32%' }}>
              <div className="addressBodyRow">Fax *</div>
              <div className="addressBodyRow">
                <input
                  className="addressBookSearh h-8"
                  type="text"
                  name="insuranceFax"
                  value={formData.insuranceFax}
                  onChange={handleChange}
                  maxLength="15"
                  placeholder="(000) 000-0000"
                />
                <p className="error-msg">
                  {errors?.insuranceFax && errors?.insuranceFax?.message}
                </p>
              </div>
            </div>
          </div>

          {/* BUTTONS */}
          <div className="addressBodyRow flex gap-2 justify-end">
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={onSaveUpdate}>
              {editPopup?.referringMasterId ? 'Update' : 'Save'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddEditReferralInsurancePopup;
